<script setup>
import InputField from "@/Components/InputField.vue";
import PrimaryBtn from "@/Components/PrimaryBtn.vue";

import { useForm } from "@inertiajs/vue3";
import { ref, inject } from "vue";
const route = inject('route');

const showConfirmPassword = ref(false);

const form = useForm({
  password: "",
});

const submit = () => {
  form.delete(route("profile.destroy"), {
    onFinish: () => form.reset(),
    preserveScroll: true,
  });
};
</script>

<template>
  <div class="p-6 bg-white border border-red-200 rounded-lg shadow-sm">
    <div class="mb-6">
      <div class="flex items-center gap-2 mb-2">
        <svg
          class="w-5 h-5 text-red-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M8.485 3.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.19-1.458-1.515-2.625L8.485 3.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
            clip-rule="evenodd"
          />
        </svg>
        <h2 class="text-xl font-semibold text-red-900">Hapus Akun</h2>
      </div>
      <p class="text-sm text-red-700">
        Setelah akun Anda dihapus, semua sumber daya dan data akan dihapus
        secara permanen. Tindakan ini tidak dapat dibatalkan.
      </p>
    </div>

    <ErrorMessages :errors="form.errors" />

    <div
      v-if="showConfirmPassword"
      class="p-4 border border-red-200 rounded-lg bg-red-50"
    >
      <form @submit.prevent="submit" class="space-y-4">
        <InputField
          label="Konfirmasi Kata Sandi"
          icon="key"
          type="password"
          v-model="form.password"
          required
          placeholder="Masukkan kata sandi untuk konfirmasi"
          autocomplete="current-password"
        />

        <div class="flex items-center gap-3 pt-2">
          <PrimaryBtn
            :disabled="form.processing"
            class="bg-red-600 hover:bg-red-700 focus:ring-red-500"
          >
            <span v-if="form.processing">Menghapus...</span>
            <span v-else>
              <i class="mr-2 fa-solid fa-triangle-exclamation"></i>
              Konfirmasi Hapus
            </span>
          </PrimaryBtn>

          <button
            type="button"
            @click="showConfirmPassword = false"
            class="px-4 py-2 text-sm font-medium transition-colors duration-200 bg-white border rounded-md text-slate-700 border-slate-300 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:ring-offset-2"
          >
            Batal
          </button>
        </div>
      </form>
    </div>

    <div
      v-if="!showConfirmPassword"
      class="flex items-center justify-between pt-4 border-t border-red-200"
    >
      <div>
        <p class="text-sm text-slate-600">
          Apakah Anda yakin ingin menghapus akun ini?
        </p>
      </div>
      <button
        @click="showConfirmPassword = true"
        class="inline-flex items-center px-4 py-2 text-sm font-medium text-white transition-colors duration-200 bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
      >
        <i class="mr-2 fa-solid fa-triangle-exclamation"></i>
        Hapus Akun
      </button>
    </div>
  </div>
</template>
